import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { ItemDetailCustomizeText } from "./itemDetailCustomize";
export const AddMealButton = ({ cardControlProps: { isAddDisabled, isSingleSelect, handleToggle, handleQuantityIncrement, quantity }, hasAssignments, }) => {
    if (isSingleSelect) {
        // In single-selection mode, we do not respect isAddDisabled.
        // Instead, we follow these rules:
        //
        // - If the recipe has already been added the "Add Meal" button should no longer display, preventing another addition.
        // - If the recipe has not been added the "Add Meal" button should be available for selection.
        if (hasAssignments)
            return null;
    }
    else if (isAddDisabled) {
        // In increment/decrement mode, we respect isAddDisabled.
        // If isAddDisabled is true, the "Add Meal" button should not be displayed.
        return null;
    }
    return (_jsx(Button, Object.assign({ variant: "outlined", disabled: !isSingleSelect && isAddDisabled, onClick: () => {
            if (isSingleSelect && handleToggle) {
                handleToggle();
            }
            else if (!!handleQuantityIncrement) {
                handleQuantityIncrement(true, false);
            }
        } }, { children: ItemDetailCustomizeText.ADD_MEAL })));
};
